// =============================================================
// APP — entry composition · GSAP boot + LandingPage
// Native scroll (Lenis kaldırıldı — scrollbar gizliyordu)
// =============================================================

import "./styles/tokens.css";
import "./styles/layers.css";
import "./styles/typography.css";
import "./styles/motion.css";

import { useEffect } from "react";
import { LandingPage } from "./features/landing/LandingPage";
import { registerGsap } from "./lib/animation/gsap";

export function App() {
  useEffect(() => {
    registerGsap();
  }, []);

  return <LandingPage />;
}